import {createAction} from "@reduxjs/toolkit";
import * as types from "../constants/ActionTypes";

export const fetchAvailabilities = createAction(types.FETCH_AVAILABILITIES);
export const fetchAvailabilitiesFailure = createAction(types.FETCH_AVAILABILITIES_FAILURE, (error) => ({error}));
export const fetchAvailabilitiesSuccess = createAction(types.FETCH_AVAILABILITIES_SUCCESS);

export const fetchAvailabilitiesDms = createAction(types.FETCH_AVAILABILITIES_DMS);
export const fetchAvailabilitiesDmsFailure = createAction(types.FETCH_AVAILABILITIES_DMS_FAILURE, (error) => ({error}));
export const fetchAvailabilitiesDmsSuccess = createAction(types.FETCH_AVAILABILITIES_DMS_SUCCESS);
